import _ from "lodash";
import {
  Component,
} from "react";
import store from "CommonState/store";
import Confirmation from "CommonComponents/confirmation";
import {
  Button,
} from "react-bootstrap";
import {
  Awesome, Panel,
} from "CommonComponents/bricks";
import {
  updateStats,
} from "Components/db-widget-angaben";
import {
  ASTMODUSKEY,
} from "App/constants";

// Zum Generieren von Links und Texten brauche ich Schema und Subpanels
import {
  subpanels as subpanels_stamm,
} from "App/person-stamm-tab";
import {
  subpanels as subpanels_studien,
} from "App/person-studien-tab";
import {
  subpanels as subpanels_lbvperson,
} from "App/person-lbvperson-tab";
import {
  subpanels as subpanels_lbvstatus,
} from "App/person-lbvstatus-tab";
import {
  subpanels as subpanels_weiterebv,
} from "App/person-beschaeftigung-tab";
const panels = [...subpanels_stamm, ...subpanels_studien, ...subpanels_lbvperson, ...subpanels_lbvstatus, ...subpanels_weiterebv];

@store("flag_antragstellermodus")
export default class PersonValidierungPopup extends Component {
  constructor() {
    super();
    this.state = { flag_angabenstatus: {} };
  }

  componentDidMount = async() => {
    const status = await updateStats(this.props);
    this.setState({ flag_angabenstatus: status });
  };

  componentDidUpdate = async prevProps => {
    if (!prevProps.flag_antragstellermodus && this.props.flag_antragstellermodus) {
      const status = await updateStats(this.props);
      this.setState({ flag_angabenstatus: status });
    }
  };

  findTab(gruppe) {
    // Feststellen, in welchem Bereich (Tab in den persönlichen Daten) eine Gruppe angezeigt wird
    for (const panel of panels) {
      if (panel.endpoint.endsWith(`/${ gruppe }`)) {
        return this.customizeTabLabel({ route: panel.route, label: panel.label }, panel.key);
      }
    }
  }

  findSubItemField = (name, list) => {
    for (const fld of list) {
      if (fld.field == name) {
        return fld;
      } else if (fld.subitems) {
        const subfld = this.findSubItemField(name, fld.subitems);
        if (subfld) {
          return subfld;
        }
      }
    }
  };

  findField = name => {
    for (const panel of panels) {
      const fld = this.findSubItemField(name, panel.schema.table);
      if (fld) {
        return { schema: fld, panel: panel };
      }
    }
  };

  customizeTabLabel(tab, key) {
    const lehrvertrag = this.props.flag_antragstellermodus === ASTMODUSKEY.Lehrauftrag;
    const tarifvertrag = this.props.flag_antragstellermodus === ASTMODUSKEY.Tarif;
    if (key === "studienbereich" || key === "werdegang") {
      tab.label = lehrvertrag ? "Qualifikation" : tarifvertrag ? "Ausbildung" : "Studentische / Wissenschaftliche Daten";
    }
    if (key === "hilfskraft") {
      tab.label = lehrvertrag ? "weitere Lehraufträge" : "vorherige / weitere Beschäftigungsverhältnisse";
    }
    return tab;
  }

  render() {
    const { flag_angabenstatus, errorMessage } = this.state;

    if (_.isEmpty(flag_angabenstatus)) {
      return null;
    }

    // Daten aufbereiten
    const gruppen = _.filter(Object.keys(flag_angabenstatus), gruppe => !_.isEmpty(flag_angabenstatus[gruppe]));
    const tmp = [];
    {
      _.map(gruppen, gruppe => {
        const item = {};
        item.list = _.map(flag_angabenstatus[gruppe], field => {
          const fld = this.findField(field);
          return { field: field, panel: (fld ? fld.panel : null), label: fld ? `${ fld.schema.display }` : field };
        });
        item.endpoint = gruppe;
        const tab = this.findTab(gruppe);
        if (tab) {
          item.tab = tab.label;
          tmp.push(item);
        }
      });
    }

    const tree = {};

    _.map(tmp, item => {
      let tab = tree[item.tab];
      if (!tab) {
        // Eintrag für Tab
        tab = {
          label: item.tab,
          route: this.findTab(item.endpoint).route,
          subpanels: {},
        };
        tree[item.tab] = tab;
      }

      _.map(item.list, field => {
        if (field.panel) {
          let sub = tab.subpanels[field.panel.key];
          if (!sub) {
            sub = {
              label: field.panel.header,
              key: field.panel.key,
              fields: [],
            };
            tab.subpanels[field.panel.key] = sub;
          }
          sub.fields.push(field);
        }
      });
    });

    return (
      <Confirmation
        header='Prüfung der persönlichen Angaben'
        action='Ok'
        actionStyle='primary'
        onConfirm={this.onConfirm}
        onCancel={this.onCancel}
        errorMessage={errorMessage}
      >

        {_.isEmpty(gruppen) && <table><tbody><tr><td><Awesome className='success' name='check-circle' style={{ fontSize: "325%" }} /></td><td><h5 style={{ marginLeft: "1em" }}>Ihre persönlichen Angaben sind vollständig.</h5></td></tr></tbody></table>}

        {!_.isEmpty(gruppen) && (
          <span>
            <h5>Ihre persönlichen Angaben sind noch nicht vollständig:</h5>
            <br />

            {_.map(tree, tab => <Panel key={tab.route}><h4><Button variant='link' data-message={tab.route} onClick={this.gotoLink}>{tab.label}</Button></h4>
              <ul>
                {_.map(tab.subpanels, subpanel => <li key={subpanel.key}> <Button variant='link' data-message={`${ tab.route }#${ subpanel.key }`} onClick={this.gotoLink}>{subpanel.label}</Button> <ul>
                  {_.map(subpanel.fields, field => <li key={field.field}>{field.label}</li>)}
                </ul>
                </li>)}
              </ul></Panel>)}
          </span>
        )
        }

      </Confirmation>
    );
  }

  gotoLink = e => {
    const route = e.target.getAttribute("data-message");
    this.props.onClose(route);
  };

  onConfirm = () => {
    // ...

    this.props.onClose();
  };

  onCancel = () => {
    this.props.onClose();
  };
}
